import * as commonActions from './commonActions';

import reportingApi from '../api/reportingApi';

export function loadDashboard() {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadDashboard(getState().authenticationState.token).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadRendicontazione(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadRendicontazione(getState().authenticationState.token, filters).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function exportRendicontazione(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.exportRendicontazione(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadEstrattoConto(filters, pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadEstrattoConto(getState().authenticationState.token, filters, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function estrattoContoExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.estrattoContoExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function marcaPagatoAllaCompagnia(ids, targetDate, amount, note) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.marcaPagatoAllaCompagnia(getState().authenticationState.token, ids, targetDate, amount, note).then(res => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadEstrattoContoSociSostenitori(filters, pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadEstrattoContoSociSostenitori(getState().authenticationState.token, filters, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function estrattoContoSociSostenitoriExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.estrattoContoSociSostenitoriExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadEstrattoContoReferenti(filters, pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadEstrattoContoReferenti(getState().authenticationState.token, filters, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function estrattoContosociReferentiExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.estrattoContosociReferentiExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadEstrattoContoQuoteSociSostenitori(filters, pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadEstrattoContoQuoteSociSostenitori(getState().authenticationState.token, filters, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function estrattoContoQuoteSociSostenitoriExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.estrattoContoQuoteSociSostenitoriExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function marcaPagatoAlSocioSostenitore(ids, targetDate, networkRights, rimessoNetworkNote) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.marcaPagatoAlSocioSostenitore(getState().authenticationState.token, ids, targetDate, networkRights, rimessoNetworkNote).then(res => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function marcaPagatoAlReferente(ids, targetDate, referenteRights) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.marcaPagatoAlReferente(getState().authenticationState.token, ids, targetDate, referenteRights).then(res => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadEstrattoContoXSocioSostenitore(filters, pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadEstrattoContoXSocioSostenitore(getState().authenticationState.token, filters, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function estrattoContoXSocioSostenitoreExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.estrattoContoXSocioSostenitoreExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadEstrattoContoIncassi(filters, pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadEstrattoContoIncassi(getState().authenticationState.token, filters, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function estrattoContoIncassiExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.estrattoContoIncassiExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function notificaScadenzaPagamentoQuietanza(accountPeriodId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.notificaScadenzaPagamentoQuietanza(getState().authenticationState.token, accountPeriodId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadCertificazioneIncassi(filters, pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadCertificazioneIncassi(getState().authenticationState.token, filters, pagingModel).then((res) => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function printCertificazioneIncassi(contractId, year) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.printCertificazioneIncassi(getState().authenticationState.token, contractId, year).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function confirmAndSaveCertificazioneIncassi(contractId, year) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.confirmAndSaveCertificazioneIncassi(getState().authenticationState.token, contractId, year).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function confirmAndSaveAllCertificazioneIncassi(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.confirmAndSaveAllCertificazioneIncassi(getState().authenticationState.token, filters).then((message) => {
            dispatch(commonActions.unlockScreen());
            return message;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
} 

export function confirmAndSendCertificazioneIncassi(contractId, year) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.confirmAndSendCertificazioneIncassi(getState().authenticationState.token, contractId, year).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function downloadCertificazioneIncassi(contractId, year) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.downloadCertificazioneIncassi(getState().authenticationState.token, contractId, year).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function certificazioneIncassiExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.certificazioneIncassiExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadEstrazioneAnagrafiche(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.loadEstrazioneAnagrafiche(getState().authenticationState.token, filters).then((res) => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function estrazioneAnagraficheExport(filters) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return reportingApi.estrazioneAnagraficheExport(getState().authenticationState.token, filters).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}
